import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

const AUTH_STORAGE_KEY = 'tbs_crm_auth_user_v3';

export const DEFAULT_ADMIN = {
  id: 'USR-101',
  username: 'admin',
  passwordHash: 'admin123',
  name: 'TBS Administrator',
  role: 'System Administrator',
  email: 'admin@tbs-crm.com',
  avatar: 'TS'
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem(AUTH_STORAGE_KEY);
      return saved ? JSON.parse(saved) : DEFAULT_ADMIN;
    } catch {
      return DEFAULT_ADMIN;
    }
  });

  const [authError, setAuthError] = useState('');

  const login = (username, password) => {
    setAuthError('');
    const cleanUser = username?.trim().toLowerCase();
    const cleanPass = password?.trim();

    const expectedUser = user?.username || 'admin';
    const expectedPass = user?.passwordHash || 'admin123';

    if (cleanUser === expectedUser && cleanPass === expectedPass) {
      setUser(user || DEFAULT_ADMIN);
      localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user || DEFAULT_ADMIN));
      return { success: true };
    } else {
      const errorMsg = `Invalid username or password. (Default: ${expectedUser} / ${expectedPass})`;
      setAuthError(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

  const updateProfile = (updatedFields) => {
    const updatedUser = { ...user, ...updatedFields };
    setUser(updatedUser);
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(updatedUser));
    return updatedUser;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem(AUTH_STORAGE_KEY);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated: Boolean(user),
        login,
        logout,
        updateProfile,
        authError
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
